<template>
    <ob1-popin-modal2
        v-if="conditions"
        :id="modalId"
        :aria-labelledby="modalId+'-modal'"
    >
        <h4>Le bonus reprise</h4>
        <div class="bg-greige px-1 my-1 my-md-2">
            <p class="mb-0">
                <strong>Lors du rachat de votre ancien mobile, on ajoute un bonus au prix de reprise estimé.</strong>
            </p>
        </div>
        <div class="px-1">
            <p class="mb-0">
                <strong>Par exemple&nbsp;:</strong>
            </p>
            <p v-html="exampleTextHtml" />
            <p class="small" v-html="conditions" />
            <p class="small">
                *Valeur à titre d’exemple. La valeur réelle de votre mobile actuel est déterminée en fonction du modèle et de son état.
            </p>
        </div>
    </ob1-popin-modal2>
</template>

<script>

export default {
    props: {
        conditions: {
            type: String,
            required: true
        },
        modalId: {
            type: String,
            required: true
        }
    },
    computed: {
        exampleTextHtml() {
            return "Reprise de votre<br>ancien mobile :\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0200 €*<br><br>Bonus reprise :\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0+ 100 €*<br>------------------------------------<br>Prix final de reprise<br>du mobile\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0= 300 €*"
        }
    }
}
</script>

<style scoped lang="scss">
</style>
